import React, { useState } from 'react';
import { Input, Button, Modal, Spin } from 'antd';
import { useDefectCauseForm } from './hooks/useDefectCauseForm';

const P111Form: React.FC = () => {
  const {
    mode, isEditing, loading,
    records, current, currentIdx,
    code, setCode,
    nameCh, setNameCh,
    nameEn, setNameEn,
    navFirst, navPrev, navNext, navLast,
    startAdd, startEdit, cancel, save,
    doDelete, quickSearch,
  } = useDefectCauseForm();

  const [searchText, setSearchText] = useState('');

  const handleDelete = () => {
    if (!current) return;
    Modal.confirm({
      title: '確認刪除',
      content: `確定要刪除「${current.fp020_01} ${current.fp020_11}」？`,
      okText: '刪除',
      okType: 'danger',
      cancelText: '取消',
      onOk: doDelete,
    });
  };

  const handleQuickSearch = () => {
    if (searchText.trim()) {
      quickSearch(searchText.trim());
    }
  };

  const modeLabel = mode === 'add' ? '新增' : mode === 'edit' ? '修改' : '瀏覽';

  return (
    <Spin spinning={loading}>
      <div className="max-w-2xl mx-auto p-6">
        {/* Title */}
        <h2 className="text-xl font-bold mb-4">
          瑕疵原因設定 (pwp111f1)
          <span className="ml-3 text-sm font-normal text-gray-500">
            [{modeLabel}] {records.length > 0 ? `${currentIdx + 1} / ${records.length}` : '無資料'}
          </span>
        </h2>

        {/* Quick Search Bar */}
        <div className="flex items-center gap-2 mb-4">
          <Input
            placeholder="輸入代號快速查詢"
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
            onPressEnter={handleQuickSearch}
            disabled={isEditing}
            style={{ width: 300 }}
            maxLength={4}
          />
          <Button onClick={handleQuickSearch} disabled={isEditing}>查詢</Button>
        </div>

        {/* Navigation Bar */}
        <div className="flex items-center gap-1 mb-4">
          <Button size="small" onClick={navFirst} disabled={isEditing || records.length === 0}>|&lt;</Button>
          <Button size="small" onClick={navPrev} disabled={isEditing || currentIdx <= 0}>&lt;</Button>
          <Button size="small" onClick={navNext} disabled={isEditing || currentIdx >= records.length - 1}>&gt;</Button>
          <Button size="small" onClick={navLast} disabled={isEditing || records.length === 0}>&gt;|</Button>
        </div>

        {/* Form Fields */}
        <div className="space-y-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">瑕疵因代號 (FP020_01)</label>
            <Input
              value={code}
              onChange={e => setCode(e.target.value)}
              maxLength={4}
              disabled={mode === 'edit'}
              style={{ width: 200 }}
              placeholder="最多4碼"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">中文名稱 (FP020_11)</label>
            <Input
              value={nameCh}
              onChange={e => setNameCh(e.target.value)}
              maxLength={30}
              disabled={!isEditing}
              style={{ width: 400 }}
              placeholder="最多30字"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">英文名稱 (FP020_13)</label>
            <Input
              value={nameEn}
              onChange={e => setNameEn(e.target.value)}
              maxLength={40}
              disabled={!isEditing}
              style={{ width: 500 }}
              placeholder="最多40字 (選填)"
            />
          </div>
        </div>

        {/* Audit Fields (read-only) */}
        {current && mode === 'browse' && (
          <div className="text-xs text-gray-400 mb-6 space-y-1">
            <div>建立者: {current.fp020_91} | 建立日期: {current.fp020_92 || '-'}</div>
            <div>修改者: {current.fp020_93}</div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex items-center gap-2">
          {!isEditing ? (
            <>
              <Button type="primary" onClick={startAdd}>新增</Button>
              <Button onClick={startEdit} disabled={!current}>修改</Button>
              <Button danger onClick={handleDelete} disabled={!current}>刪除</Button>
            </>
          ) : (
            <>
              <Button type="primary" onClick={save}>儲存</Button>
              <Button onClick={cancel}>取消</Button>
            </>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default P111Form;
